import { useState } from "react"
import { HERO_SLIDERS_API } from "../../../../Utilities/APIs/APIs"
import { useEffect } from "react"
import Form from "../../../Partials/Layouts/Forms/Form"
import ImageInput from "../../../Partials/Layouts/Forms/FormInputs/ImageInput/ImageInput"
import NumberInput from "../../../Partials/Layouts/Forms/FormInputs/NumberInput/NumberInput"
import FormSubmitButton from "../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton"
import LinkInput from "../../../Partials/Layouts/Forms/FormInputs/LinkInput/LinkInput"
import useAxiosInstance from "../../../../Utilities/Hooks/useAxiosInstance"




function UpdateHeroSlider({

    targetID, employee, setShowUpdateForm, setShowModal, triggerFetch

}) {
    const [link, setLink] = useState('')
    const [image, setImage] = useState('')
    const [image1, setImage1] = useState('')
    const [precedence, setPrecedence] = useState('')

    const axiosInstance = useAxiosInstance()

    useEffect(() => {

        async function fetchAndSetSliderInfo() {

            const { data } = await axiosInstance.get(HERO_SLIDERS_API + 'getSingleHeroSlider/' + targetID)

            setLink(data.link);
            setImage(data.image);
            setImage1(data.image1);
            setPrecedence(data.precedence);
        }
        fetchAndSetSliderInfo()
    }, [targetID, axiosInstance])

    async function handleSubmit(e) {

        const itemData = new FormData()
        itemData.append('link', link)
        itemData.append('image', image)
        itemData.append('image1', image1)
        itemData.append('precedence', precedence)

        const response = await axiosInstance.patch(HERO_SLIDERS_API + targetID, itemData)

        if (response) {

            setShowUpdateForm(false);
            setShowModal(false);
            triggerFetch()
        }

    }

    return (
        <Form onSubmit={handleSubmit} hasImage>
            <LinkInput
                value={link}
                setState={setLink}

            />
            <ImageInput
                fieldId='1'
                state={image}
                setState={setImage}
                allowUpdateImage
            >
                Upload Card Image
            </ImageInput>
            <ImageInput
                fieldId='2'
                state={image1}
                setState={setImage1}
                allowUpdateImage
            >
                Upload Card Mobile Image
            </ImageInput>
            <NumberInput
                label={`Precedence`}
                value={precedence}
                placeholder={`Enter Precedence`}
                setState={setPrecedence}
            />


            {/* <ImageInput fieldId='1' state={image} setState={setImage} allowCreateImage>Upload Card Image</ImageInput> */}

            <FormSubmitButton text='Update Hero Slider' />
        </Form>
    )
}

export default UpdateHeroSlider